import { LazyLoadImage } from "react-lazy-load-image-component";
import { IMAGE_ADDRESS } from '../../../../apis';
import { handleChangeDataModalStory } from '../../../../redux/actions/partials/modals/modalStory';




const cardStory = (props) => {
    const { dispatch } = props;

    const handleShowStory = () => {
        dispatch(handleChangeDataModalStory('story', props.data));
        dispatch(handleChangeDataModalStory('isOpen', true));
        setTimeout(() => dispatch(handleChangeDataModalStory('isActive', true)), 0);
    }

    return (

    	<div onClick={handleShowStory} className="ml-3 lg:ml-0 mr-2 w-[84px] shrink-0 cursor-pointer">
            <div className="styles_container__ipSg9 rounded-circle shrink-0 w-full aspect-square relative flex items-center justify-center">
                <div className="rounded-circle overflow-hidden bg-white aspect-square styles_innerContainer__6FPF0 flex items-center justify-center">
                    <div className="rounded-circle overflow-hidden flex items-center justify-center styles_image__ggcBy" style={{borderRadius: '99999px', lineHeight: '0'}} >
                        <LazyLoadImage className="w-full inline-block" src={IMAGE_ADDRESS + props.data.image} alt="" title={props.data.title} style={{objectFit: 'cover', borderRadius: '99999px'}} />
                    </div>
                </div>
            </div>
            <div className="mt-2 text-caption text-center text-neutral-800 ellipsis-2">{props.data.title}</div>
        </div>

    );
}

export default cardStory;